import { ENDPOINTS } from "../endpoint";
import axiosInstance from "../axiosInstance";

export const AdminGetAllOrder = async (token) => {
    const response = await axiosInstance.get(ENDPOINTS.AdminGetAllOrder, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}
export const AdminGetOrderById = async (token, id) => {
    const response = await axiosInstance.get(`${ENDPOINTS.AdminGetOrderById}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}
export const AdminUpdateOrder = async (token, id, data) => {
    const response = await axiosInstance.put(`${ENDPOINTS.AdminUpdateOrder}/${id}`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

